import { defineMessages } from 'react-intl'

export default defineMessages({
  'national-tv': {
    id: 'data.mediums.national-tv',
    defaultMessage: 'National TV',
  },
  'national-radio': {
    id: 'data.mediums.national-radio',
    defaultMessage: 'National Radio',
  },
  'paid-online': {
    id: 'data.mediums.paid-online',
    defaultMessage: 'Paid Online',
  },
  'national-cinema': {
    id: 'data.mediums.national-cinema',
    defaultMessage: 'National Cinema',
  },
})
